<template>
  <div class="reveal modal_transparent large">
    <div class="modal_shops">
      <button class="close-button close_btn_modal" data-close aria-label="Close modal" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="modal_shops_header">
        <div class="shop-name">{{ name }}</div>
        <ul id="shops-tabs" class="modal_shops_menu tabs" data-tabs>
          <li :class="{'tabs-title': true, 'is-active': shownTab === 0}" @click="shownTab = 0" ><a href="#panel1" class="active_link_modal">{{ localize.KZ_SHOPS_ON_MAP }}</a></li>
          <li :class="{'tabs-title': true, 'is-active': shownTab === 1}" @click="shownTab = 1"  v-if="shopCenterPhotoPath"><a href="#panel2">{{ localize.KZ_SHOPS_SHOPPING_CENTER }}</a></li>
          <li :class="{'tabs-title': true, 'is-active': shownTab === 2}" @click="shownTab = 2"  v-if="shopPhotoPath"><a href="#panel3">{{ localize.KZ_SHOPS_SHOP }}</a></li>
          <li :class="{'tabs-title': true, 'is-active': shownTab === 3}" @click="shownTab = 3"  v-if="shopCenterSchemePhotoPath"><a href="#panel4">{{ localize.KZ_SHOPS_ON_SHOP_SCHEME }}</a></li>
        </ul>
      </div>
      <div class="tabs-content" data-tabs-content="shops-tabs">
        <div :class="{'tabs-panel': true, 'is-active': shownTab === 0, 'modal_block': true}" id="panel1">
          <div class="shops_map__modal">
            <single-shop-map v-if="coords" :coords="mapCoords" :name="name" :key="name + coords"/>
          </div>
          <div class="modal_contact">
            <div class="contact_list_header">{{ localize.KZ_SHOPS_ADDRESS }}</div>
            <p class="shop_subway" v-if="metroName">{{ metroName }}</p>
            <p class="shop_adress adress" v-if="address">{{ address }}</p>
            <div class="contact_list_header">
              {{ localize.KZ_SHOPS_PHONE }}
            </div>
            <p class="shop_adress phone" v-if="phone"><a :href="phoneString"> {{ phone }} </a></p>
            <p class="mark_add">{{ localize.KZ_SHOPS_OFFICE }}</p>
            <div class="contact_list_header">
              {{ localize.KZ_SHOPS_WORKING_HOURS }}
            </div>
            <p class="shop_adress working_hours" v-if="workingTime">{{ workingTime }}</p>
            <p class="mark_add">{{ localize.KZ_SHOPS_NO_WEEKENDS }}</p>

          </div>
        </div>
        <div :class="{'tabs-panel': true, 'is-active': shownTab === 1}" id="panel2" :style="{ background: shopCenterPhotoBackground }"></div>
        <div :class="{'tabs-panel': true, 'is-active': shownTab === 2}" id="panel3" :style="{ background: shopPhotoBackground }"></div>
        <div :class="{'tabs-panel': true, 'is-active': shownTab === 3}" id="panel4" :style="{ background: shopCenterSchemePhotoBackground }"></div>
      </div>
    </div>
  </div>
</template>
<script>
import SingleShopMap from './single-shop-map.vue';

export default {
  props: {
    coords: String,
    shopCenterPhotoPath: String,
    shopPhotoPath: String,
    shopCenterSchemePhotoPath: String,
    name: {
      type: String,
      required: false
    },
    metroName: String,
    cityName: String,
    address: {
      type: String,
      required: false
    },
    phone: {
      type: String,
      required: false
    },
    phoneString: {
      type: String,
      required: false
    },
    phoneExt: String,
    workingTime: {
      type: String,
      required: false
    },
  },
  data: () => {
    return {
      shownTab: 0
    };
  },
  mounted() {
    $(this.$el).on('')
  },
  computed: {
    shopCenterPhotoBackground() {
      return this.shopCenterPhotoPath ? `url(${this.shopCenterPhotoPath}) center/contain no-repeat` : '';
    },
    shopPhotoBackground() {
      return this.shopPhotoPath ? `url(${this.shopPhotoPath}) center/contain no-repeat` : '';
    },
    shopCenterSchemePhotoBackground() {
      return this.shopCenterSchemePhotoPath ? `url(${this.shopCenterSchemePhotoPath}) center/contain no-repeat` : '';
    },
    localize() {
      return BX.Vue.getFilteredPhrases('KZ_SHOPS_');
    },
    mapCoords() {
      return this.coords.split(',');
    }
  },
  components: {
    'single-shop-map': SingleShopMap,
  }
}
</script>
